import { Routes, Route, NavLink, useLocation } from 'react-router-dom';
import { Dashboard } from './pages/Dashboard';
import { NewDesign } from './pages/NewDesign';
import { JobDetail } from './pages/JobDetail';
import { Products } from './pages/Products';
import { Settings } from './pages/Settings';

export function App() {
  const location = useLocation();

  const navItems = [
    { to: '/', label: 'Dashboard', end: true },
    { to: '/new', label: 'New Design', end: false },
    { to: '/products', label: 'Products', end: false },
    { to: '/settings', label: 'Settings', end: false },
  ];

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header__logo">
          <span className="app-header__logo-mark" />
          <span>CalitoyStamp</span>
          <span style={{ fontSize: '0.7rem', color: 'var(--ink-faint)', fontWeight: 400, marginLeft: '4px' }}>
            admin
          </span>
        </div>
        <nav className="app-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `app-nav__link ${isActive ? 'app-nav__link--active' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="app-main">
        <Routes location={location}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/new" element={<NewDesign />} />
          <Route path="/job/:id" element={<JobDetail />} />
          <Route path="/products" element={<Products />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </main>
    </div>
  );
}
